import visaLogo from '../../../assets/icons/logo-card-visa.svg';
import mastercardLogo from '../../../assets/icons/logo-card-mastercard.svg';
import amexLogo from '../../../assets/icons/logo-card-amex.svg';
import discoverLogo from '../../../assets/icons/logo-card-discover.svg';

// Maps Paddle's raw card brand (`payments[].method_details.card.type`, stored in account.card_type)
// to a colored logo asset. Brands without a bundled asset (diners_club, jcb, union_pay, maestro,
// unknown, …) return undefined → the UI falls back to the generic `ico--card` icon.
const CARD_BRAND_LOGOS: Record<string, string> = {
  visa: visaLogo,
  mastercard: mastercardLogo,
  american_express: amexLogo,
  discover: discoverLogo,
};

export const getCardBrandLogo = (cardType: string | null): string | null =>
  (cardType && CARD_BRAND_LOGOS[cardType]) || null;
